import { CreditCard } from "../types";
import axios from "axios";

export interface ICreditCard {
    tokenize(ccInfo: CreditCard): Promise<string>;
    sessionProps: { [key: string]: string };
}
export class CreditCardFactory {
    static getHelper(settings: { [key: string]: string }): ICreditCard {
        if (!settings) return new PayvisionCreditCard(settings);
        const serviceProvider = settings.serviceName;
        switch (serviceProvider) {
            case 'Vesta':
                return new VestaCreditCard(settings);
            case 'Cybersource':
                return new CybersourceCreditCard(settings);
            case 'PayVision':
                return new PayvisionCreditCard(settings);
            case 'Checkout':
                return new CheckoutCreditCard(settings);
            default:
                return new CybersourceCreditCard(settings);
        }
    }
}
export class CheckoutCreditCard implements ICreditCard {
    _params: { [key: string]: string };
    constructor(params: { [key: string]: string }) {
        this._params = params;
    }
    get sessionProps() {
        return this._params;
    }
    async tokenize(ccInfo: CreditCard): Promise<string> {
        const publicKey = this._params.accountName;
        const url = this._params.tokenizeUrl;
        const [month, year] = ccInfo.expiryMonthyear.split("/");
        const obj = {
            "type": "card",
            "number": ccInfo.creditCardNumber.replace(/ /g, ''),
            "expiry_month": month,
            "expiry_year": year,
            "name": ccInfo.lastName,
            "cvv": ccInfo.cvvCode,
            "billing_address": {
                "address_line1": ccInfo.streetAddress,
                "city": ccInfo.city,
                "state": ccInfo.state,
                "zip": ccInfo.zipCode,
                "country": ccInfo.country
            }
        };
        try {
            const response = await axios.post(url, obj, {
                headers: {
                    Authorization: publicKey,
                    "Content-Type": "application/json"
                }
            });
            return response.data.token;
        }
        catch (e) {
            return "";
        }
    }
}
// tslint:disable-next-line:max-classes-per-file
export class VestaCreditCard implements ICreditCard {
    _params: { [key: string]: string };
    constructor(params: { [key: string]: string }) {
        this._params = params;
    }
    get sessionProps() {
        return this._params;
    }
    tokenize(ccInfo: CreditCard): Promise<string> {
        vestatoken.init({
            //ServiceURL: "https://vsafesandboxtoken.ecustomersupport.com/GatewayV4ProxyJSON/Service",
            ServiceURL: this._params.tokenizeUrl,
            AccountName: this._params.accountName
        });
        return new Promise((resolve, reject) => {
            vestatoken.getcreditcardtoken({
                ChargeAccountNumber: ccInfo.creditCardNumber.replace(/ /g, ''),
                onSuccess: (data: any) => {
                    // make use of ‘data.ChargeAccountNumberToken’ (String), ‘data.PaymentDeviceLast4’ (String) and ‘data.PaymentDeviceTypeCD’ (String)
                    resolve(data.ChargeAccountNumberToken);
                },
                onFailed: (failure: any) => {
                    // make use of `failure` (String)
                    reject(failure);
                },
                onInvalidInput: (failure: any) => {
                    // make use of `failure` (String)
                    reject(failure);
                }
            });
        })
    }
}
// tslint:disable-next-line:max-classes-per-file
export class CybersourceCreditCard implements ICreditCard {
    _params: { [key: string]: string };
    constructor(params: { [key: string]: string }) {
        this._params = params;
    }
    get sessionProps() {
        return this._params;
    }
    async tokenize(creditCardNum: CreditCard): Promise<string> {
        return Promise.resolve("");
    }
}
// tslint:disable-next-line:max-classes-per-file
export class PayvisionCreditCard implements ICreditCard {
    _params: { [key: string]: string };
    constructor(params: { [key: string]: string }) {
        this._params = params;
    }
    get sessionProps() {
        return this._params;
    }
    async tokenize(creditCardNum: CreditCard): Promise<string> {
        return Promise.resolve("");
    }
}